"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _elements = require("../../styles/elements");

var _icons = require("../../assets/icons");

var _MessageCard = require("./MessageCard.styles");

var Container = (0, _base["default"])("div", {
  target: "e50eki30",
  label: "Container"
})(function (props) {
  return _MessageCard.styles[props.type](props);
}, ";");
var info = {
  warning: (0, _jsxRuntime.jsx)(_icons.Error, {}),
  negative: (0, _jsxRuntime.jsx)(_icons.Negative, {}),
  info: (0, _jsxRuntime.jsx)(_icons.Note, {}),
  positive: (0, _jsxRuntime.jsx)(_icons.Valid, {})
};
var variants = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
};

var MessageCard = /*#__PURE__*/_react["default"].forwardRef(function (_ref, forwardedRef) {
  var type = _ref.type,
      className = _ref.className,
      closeable = _ref.closeable,
      children = _ref.children,
      onClose = _ref.onClose,
      visible = _ref.visible,
      isIconHidden = _ref.isIconHidden;

  var _useState = (0, _react.useState)(typeof visible === 'boolean' ? !visible : false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      close = _useState2[0],
      setClose = _useState2[1];

  var _useState3 = (0, _react.useState)(visible ? false : 'closed'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
      shouldAnimateInitial = _useState4[0];

  var handleClose = (0, _react.useCallback)(function () {
    setClose(true);
    onClose();
  }, [onClose]);
  (0, _react.useEffect)(function () {
    if (typeof visible === 'boolean') {
      setClose(!visible);
    }
  }, [visible]);
  var shouldShowMessageIcon = !isIconHidden && info[type];
  return (0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
    initial: shouldAnimateInitial,
    children: !close && (0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
      variants: variants,
      initial: "closed",
      animate: "open",
      exit: "closed",
      transition: {
        opacity: {
          duration: 0.3
        }
      },
      children: (0, _jsxRuntime.jsxs)(Container, {
        type: type,
        withIconHidden: !shouldShowMessageIcon,
        withCloseBtn: closeable,
        className: className,
        ref: forwardedRef,
        children: [shouldShowMessageIcon && (0, _jsxRuntime.jsx)("span", {
          children: info[type]
        }), (0, _jsxRuntime.jsx)("div", {
          css: _elements.text.styles.textXs,
          children: children
        }), closeable && (0, _jsxRuntime.jsx)("button", {
          className: "grui",
          css: _elements.button.styles.preflight,
          type: "button",
          onClick: handleClose,
          children: (0, _jsxRuntime.jsx)(_icons.Close, {})
        })]
      })
    })
  });
});

MessageCard.propTypes = {
  /**
   * Type of message
   */
  type: (0, _propTypes.oneOf)(['warning', 'info', 'negative', 'positive', 'white']),
  className: _propTypes.string,

  /**
   * Whether show close icon and can be closed
   */
  closeable: _propTypes.bool,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * callback for when the card is closed,
   * need to set closeable to true
   */
  onClose: _propTypes.func,

  /**
   * Control whether to show the card,
   * use this when want to close it without using close button
   */
  visible: _propTypes.bool,

  /**
   * Whether hide the message type icon
   */
  isIconHidden: _propTypes.bool
};
MessageCard.defaultProps = {
  type: 'info',
  className: undefined,
  closeable: false,
  children: undefined,
  onClose: function onClose() {},
  visible: true,
  isIconHidden: false
};
MessageCard.displayName = 'MessageCard';
var _default = MessageCard;
exports["default"] = _default;
//# sourceMappingURL=MessageCard.js.map